/* eslint-disable max-len */
type PastWorkIconProps = {
  color?: string;
};

export const PastWorkIcon = ({ color = '#0069E4' }: PastWorkIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      className="icon"
      aria-hidden="true"
      focusable="false"
    >
      <g id="2-5 icons Past work">
        <path
          id="Subtract"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 26.587V6.5H25.7174V26.587H6.5ZM3.5 5.5C3.5 4.39543 4.39543 3.5 5.5 3.5H26.7174C27.822 3.5 28.7174 4.39543 28.7174 5.5V6.47835H30.4131H31.1957C33.1287 6.47835 34.6957 8.04535 34.6957 9.97835V32.0653C34.6957 33.9983 33.1287 35.5653 31.1957 35.5653H9.97834C8.04535 35.5653 6.47835 33.9983 6.47835 32.0653V31.7175V29.587H5.5C4.39543 29.587 3.5 28.6915 3.5 27.587V5.5ZM9.47835 29.587V31.7175V32.0653C9.47835 32.3414 9.7022 32.5653 9.97834 32.5653H31.1957C31.4719 32.5653 31.6957 32.3414 31.6957 32.0653V9.97835C31.6957 9.7022 31.4719 9.47835 31.1957 9.47835H30.4131H28.7174V27.587C28.7174 28.6915 27.822 29.587 26.7174 29.587H9.47835Z"
          fill={color}
        />
        <path
          id="Vector 9"
          d="M11.5 17L14.5 20L21 13.5"
          stroke={color}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
